import React from 'react';

export default () => (
  <section className='container-fluid bggray py-4'>
        <div className='row m-2-hor'>

          <div className='col-lg-3 col-md-6'>
            <div className='featurehome'>
              <div className='img'>
                <i className="fa fa-comments-o"></i>
              </div>
              <div className='text'>
                Get Consultant
              </div>
            </div>
          </div>

          <div className='col-lg-3 col-md-6'>
            <div className='featurehome'>
              <div className='img'>
                <i class="fa fa-list-alt"></i>
              </div>
              <div className='text'>
                Set
                Schedule
              </div>
            </div>
          </div>

          <div className='col-lg-3 col-md-6'>
            <div className='featurehome'>
              <div className='img'>
                <i className="fa fa-cogs"></i>
              </div>
              <div className='text'>
                Set
                Package
              </div>
            </div>
          </div>

          <div className='col-lg-3 col-md-6'>
            <div className='featurehome last'>
              <div className='img'>
                <i className="fa fa-line-chart"></i>
              </div>
              <div className='text'>
                Build in 
                Growth
              </div>
            </div>
          </div>

        </div>
      </section>
);
